/**
 * The launcher follows the site's language switcher.
 *
 * Its own module, deliberately import-light: the router's locale gate calls
 * this, so importing anything that leads back to the route table (as the boot
 * module's `currentLang` does for its path-guessing) would close a cycle that
 * only survives today because of function hoisting. The gate already knows the
 * code — folding it here needs only the shared alias map.
 */
import { canonicalLang } from '@shared/config/i18n';

export function setSupportChatLanguage(code: string): void {
  if (typeof window === 'undefined') return;
  // `?? code` used to pass an unrecognised segment straight through: `/zz/features`
  // renders NotFound and STAYS there, so the gate fires with `zz` and the widget is
  // told to speak a language nothing ships. An unknown code is not a language
  // change — leave the launcher on whatever it resolved at boot.
  const canonical = canonicalLang(code.toLowerCase());
  if (!canonical) return;
  const locale = canonical.split('-')[0];
  if (window.chatwootSettings) window.chatwootSettings.locale = locale;
  try {
    window.$chatwoot?.setLocale(locale);
  } catch {
    // Not booted yet — the boot reads the page's language itself.
  }
}
